module.exports = __webpack_public_path__ + "img/IMG_20200425_193234_sm.c012fef9.jpg";